

export const PERMISSIONS_CONFIG = [
    { key: "dashboard", label: "Tableau de bord & analyses", routes: ["dashboard", "revenue", "bestProduct"] },
    { key: "produits", label: "Gestion des produits", routes: ["productGrid", "productManagement", "addProduct", "addProduct/:id"] },
    { key: "commandes", label: "Commandes", routes: ["commandes"] },
    { key: "statistiques", label: "Statistiques", routes: ["statistiques"] },
    { key: "avis", label: "Avis clients", routes: ["avis"] },
    { key: "clients", label: "Clients", routes: ["clients"] },
    { key: "contenu", label: "Contenu (bannières, publicité, image de couverture)", routes: ["publicity", "CoverImage", "banners"] },
    { key: "transactions", label: "Transactions", routes: ["transactions"] },
    { key: "profil", label: "Profil vendeur", routes: ["profilSeller"] },
];

export const getPermissionForRoute = (routePath) => {
    const found = PERMISSIONS_CONFIG.find((p) => p.routes.includes(routePath));
    return found?.key || null;
};